import React from 'react';

import { CoreIcon } from '@aspid/ui';

import { IconCollection } from '@components/icons/iconCollection';

import type { CloseIconProperties } from './CloseIcon.types';

export const CloseIcon: React.FC<CloseIconProperties> = ({
  dataTest = 'close_icon',
  onClick,
  color = 'disabled',
  sx,
  disabled,
}) => {
  return (
    <CoreIcon
      data-testid={dataTest}
      icon={IconCollection.xmarkSolid}
      onClick={onClick}
      color={color}
      sx={sx}
      isDisabled={disabled}
    />
  );
};
